/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './faqs.css';

const questions = [
  {
    q: '¿Cómo pago mi Open Voucher?',
    a: (
      <>
        Usted podrá pagar su Open Voucher por:
        {' '}
        <br />
        - Transferencia bancaria.
        {' '}
        <br />
        - Mercado Pago en 12 o 18 cuotas.
        {' '}
        <br />
        Las cuentas bancarias para realizar las transferencias y los links de Mercado Pago se los enviará su Agente de Viajes.
      </>
    ),
  },
  {
    q: '¿Cuándo vence?',
    a: 'Se puede utilizar el Voucher hasta fines de Marzo 2021, exceptuando algunos establecimientos que tengan condiciones de uso especificas',
  },
  {
    q: 'No me llegó el Voucher - Perdí mi Voucher',
    a: 'Solicitar el mismo a su Agencia de Viajes.',
  },
  {
    q: '¿Cómo consulto cuántas noches me quedan disponibles?',
    a: 'Consultar con su Agente de Viajes, quien está en contacto con el Departamento de Reservas de los Alojamientos y lleva el registro de noches canjeadas.',
  },
  {
    q: '¿Cómo hago para viajar con mi familia?',
    a: 'Puede utilizarse en base triple o cuádruple (detallado abajo). Si son más pasajeros puede consultar cada caso con su Agente de Viajes.',
  },
  {
    q: '¿Puedo retirar mi Voucher en una Agencia GEA?',
    a: 'No hay Voucher físico, la gestión es únicamente Online.',
  },
  {
    q: '¿Se puede transferir el Open Voucher?',
    a: 'Sí, siempre y cuando el Voucher no se haya canjeado aún. Lo puede comprar una persona y en caso de que no pueda viajar en ningún momento, lo puede transferir a otra pasajero para que canjee sus noches. ',
  },
  {
    q: '¿Se puede regalar el Open Voucher?',
    a: 'Sí, se puede regalar siempre y cuando la persona que inicialmente compró el Voucher no haya canjeado noches aún.',
  },
  {
    q: '¿Puede usarse para una habitación triple?',
    a: 'El Voucher es un producto cerrado con una promo para 2 pasajeros en habitación doble. En caso de que haya una tercera persona (adulto o menor) se hablará con el hotel seleccionado para ver la posibilidad de sumar una cama adicional de forma gratuita o con un costo extra. Esto depende de cada alojamiento.',
  },
  {
    q: '¿Cómo utilizar el Voucher si son 4 pasajeros?',
    a: 'Se utilizará de 2 formas: Comprando 2 Voucher que funcionan como 2 habitaciones dobles, o canjeando 2 noches de un solo Voucher.',
  },
  {
    q: '¿Que categoría de habitación está incluida dentro del Open Voucher?',
    a: 'La primera categoría de cada alojamiento, a no ser que sea otra y esté aclarado en las condiciones de uso.',
  },
  {
    q: '¿Se puede canjear la totalidad de noches en un solo viaje?',
    a: 'Sí, pueden utilizar todas las noches del voucher en un mismo viaje. Por ejemplo: 3 noches en un hotel de Río Cuarto y 3 noches en un hotel de Córdoba capital.',
  },
  {
    q: '¿Se puede canjear 3 noches en Noviembre y 3 noches en Diciembre?',
    a: 'Sí, cada pasajero puede distribuir sus noches en distintos viajes siempre y cuando sea hasta el 31/03/2021',
  },
  {
    q: '¿Aplica para fin de semanas largos y fechas especiales?',
    a: 'Sí, excepto algunos alojamientos en los que estás aclaradas las condiciones de uso.',
  },
];
class Faqs extends React.Component {
  state = {
    show: true,
  }

  handleClickClose = () => this.setState({ show: false });

  render() {
    const { show } = this.state;
    return (
      <>
        <div className='questions-list'>
          <div className={`panel-q ${show ? '' : 'hide'}`}>
            <button
              onClick={this.handleClickClose}
              type='button'
              className='close'
              data-dismiss='modal'
              aria-label='Close'
            >
              <span aria-hidden='true'>×</span>
            </button>
            <span className='icon-faq'>
              <i className='fa fa-comments' aria-hidden='true' />
            </span>
            <h2 className='title-p'>
              Como funciona
              {' '}
              <span className='display-inline-block'>Open Voucher</span>
              ?
            </h2>
            <a
              className='btn-simple color-dinamico-fondo'
              data-target='#faq-btn'
              data-toggle='modal'
              href='#'
            >
              <span className='fa fa-comments' />
              <span className='additional'> Ver</span>
              {' '}
              preguntas frecuentes
            </a>
          </div>
        </div>
        <div className='modal fade faqs' id='faq-btn' tabIndex='-1' role='dialog' aria-labelledby='myModalLabel'>
          <div className='modal-dialog modal-lg' role='document'>
            <div className='modal-content'>
              <div className='modal-body'>
                <button type='button' className='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button>
                <br />
                <br />
                <h2 className='text-center fist-title'>Preguntas Frecuentes</h2>
                <br />
                <br />
                <div className='panel-group' id='accordion' role='tablist' aria-multiselectable='true'>
                  {questions.map((question, index) => (
                    <div className='question-container' key={question.q}>
                      <div className='' role='tab' id={`heading-${index}`}>
                        <a className='btn-coll collapsed' role='button' data-toggle='collapse' data-parent='#accordion' href={`#collapse-${index}`} aria-expanded='true' aria-controls={`collapse-${index}`}>
                          <h4 className='first'>
                            <span className='color-dinamico' />
                            {question.q}
                          </h4>
                        </a>
                      </div>
                      <div id={`collapse-${index}`} className='panel-collapse collapse' role='tabpanel' aria-labelledby={`heading-${index}`}>
                        <div className='question'>
                          <p className='second'>{question.a}</p>
                        </div>
                      </div>
                    </div>
                  ))}

                </div>
                <br />
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn-close center-block color-dinamico-fondo' data-dismiss='modal'>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Faqs;
